import { render } from "./change-sass-dialog.vue?vue&type=template&id=ff733f52&scoped=true"
import script from "./change-sass-dialog.vue?vue&type=script&lang=js"
export * from "./change-sass-dialog.vue?vue&type=script&lang=js"

import "./change-sass-dialog.vue?vue&type=style&index=0&id=ff733f52&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff733f52"]])

export default __exports__